export const ONE_ON_ONE_SIDE_BAR_REACT_QUERY_KEYS = {
  PAST_ONE_ON_ONE: 'pastOneOnOnes',
};
